export const notifications = {
  page: {
    title: 'All Notifications',
    typeFilterLabel: 'Notification Type',
    typeFilterPlaceholder: 'Noted During'
  },
  columns: {
    createdBy: 'Created By',
    message: 'Message',
    patientName: 'Patient Name',
    notificationType: 'Notification Type',
    isRead: 'Is Read',
    createdAt: 'Created At'
  }
} as const;
